export const siteConfig = {
  name: 'Evon Industrial Services',
  shortName: 'Evon',
  url: 'https://evonindustrial.com',
  phone: '(437) 435-7083',
  phoneHref: '+14374357083',
  email: 'contact@evonindustrial.com',
  serviceArea: 'Canada',
};

export const emailJsConfig = {
  serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID || 'service_qfsyxlw',
  templateId: process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'template_5a9w1wo',
  publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY || '5Oxhm4g8a9ZTDPHA6',
};

export const defaultSeo = {
  title: 'Industrial Gearbox & Hydraulic Repair Across Canada',
  description:
    'Evon Industrial Services provides industrial gearbox repair, hydraulic cylinder repair, and mechanical repair support for customers across Canada.',
  path: '/',
};

export const routeSeo = {
  '/': defaultSeo,
  '/services': {
    title: 'Industrial Repair Services Across Canada',
    description:
      'Explore Evon Industrial Services repair support for industrial gearboxes, hydraulic cylinders, and related mechanical equipment.',
    path: '/services',
  },
  '/services/hydraulics': {
    title: 'Hydraulic Cylinder Repair and Rebuilding',
    description:
      'Hydraulic cylinder repair and rebuilding support for industrial hydraulic systems, leaks, drift, pressure loss, and damaged rods.',
    path: '/services/hydraulics',
  },
  '/services/gearboxes': {
    title: 'Industrial Gearbox Repair',
    description:
      'Industrial gearbox repair support for reducers, drives, bearings, seals, shafts, vibration, overheating, leaks, and damaged gears.',
    path: '/services/gearboxes',
  },
  '/services/industrial-repair': {
    title: 'Industrial Mechanical Repair Support',
    description:
      'Industrial repair support for gearboxes, hydraulics, drive components, mechanical assemblies, and heavy-use equipment.',
    path: '/services/industrial-repair',
  },
  '/about': {
    title: 'About Evon Industrial Services',
    description:
      'Learn about Evon Industrial Services and its focus on industrial gearbox and hydraulic repair support for customers across Canada.',
    path: '/about',
  },
  '/industries': {
    title: 'Industries Served',
    description:
      'Gearbox and hydraulic repair support for manufacturing, material handling, construction, agriculture, energy, and industrial customers.',
    path: '/industries',
  },
  '/equipment': {
    title: 'Equipment Repair List',
    description:
      'Review gearbox, hydraulic, pump, motor, drive component, mill, kiln, and industrial equipment repair categories supported by Evon.',
    path: '/equipment',
  },
  '/contact': {
    title: 'Contact Evon Industrial Services',
    description:
      'Contact Evon Industrial Services for industrial gearbox repair, hydraulic repair, and equipment repair inquiries across Canada.',
    path: '/contact',
  },
  '/request-quote': {
    title: 'Contact Evon Industrial Services',
    description:
      'Contact Evon Industrial Services for industrial gearbox repair, hydraulic repair, and equipment repair inquiries across Canada.',
    path: '/contact',
  },
};

export function getSeoForPath(pathname) {
  return routeSeo[pathname] || {
    title: 'Page Not Found',
    description: 'The requested Evon Industrial Services page could not be found.',
    path: pathname,
    noindex: true,
  };
}
